import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { uploadsBaseUrl } from '../../api';
import DashboardLayout from '../../Components/Dashboard/DashboardLayout';

const formatDate = value => {
  if (!value) return 'TBA';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString();
};

const StudentDashboardPage = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const [enrollmentRes, certRes] = await Promise.all([api.get('/enrollments'), api.get('/certificates')]);
    setEnrollments(enrollmentRes.data || []);
    setCertificates(certRes.data || []);
  };

  const stats = useMemo(() => {
    const approved = enrollments.filter(e => e.status === 'approved').length;
    const completed = enrollments.filter(e => e.status === 'completed').length;
    return {
      total: enrollments.length,
      approved,
      completed,
      certificates: certificates.length,
    };
  }, [enrollments, certificates]);

  return (
    <DashboardLayout>
      <div className="container py-4">
        <h3 className="mb-3">Student Dashboard</h3>
        <div className="row g-3 my-2">
          <div className="col-md-3">
            <div className="card p-3 shadow-sm border-0">My Enrollments: {stats.total}</div>
          </div>
          <div className="col-md-3">
            <div className="card p-3 shadow-sm border-0">Approved: {stats.approved}</div>
          </div>
          <div className="col-md-3">
            <div className="card p-3 shadow-sm border-0">Completed: {stats.completed}</div>
          </div>
          <div className="col-md-3">
            <div className="card p-3 shadow-sm border-0">Certificates: {stats.certificates}</div>
          </div>
        </div>

        <h5 className="mt-4">My Courses & Enrollments</h5>
        <div className="list-group shadow-sm rounded-3 overflow-hidden">
          {enrollments.map(enrollment => (
            <div key={enrollment.id} className="list-group-item">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>{enrollment.course?.title}</strong>
                  <div className="small text-muted">Status: {enrollment.status}</div>
                  <small className="text-muted d-block">
                    Intake: {enrollment.intakeSession?.name || enrollment.intake || '-'}
                    {enrollment.intakeSession
                      ? ` (${formatDate(enrollment.intakeSession.start_date)} - ${formatDate(enrollment.intakeSession.end_date)})`
                      : ''}
                  </small>
                </div>
                <div className="d-flex gap-2">
                  {enrollment.course_id && (
                    <Link className="btn btn-sm btn-outline-primary" to={`/student/learning/${enrollment.course_id}`}>
                      Continue learning
                    </Link>
                  )}
                  {enrollment.payment_proof && (
                    <a
                      className="btn btn-sm btn-outline-secondary"
                      href={`${uploadsBaseUrl}/storage/${enrollment.payment_proof}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Payment proof
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <h5 className="mt-4">My Certificates</h5>
        <div className="list-group">
          {certificates.map(cert => (
            <div key={cert.id} className="list-group-item d-flex justify-content-between">
              <span>
                {cert.course?.title} - {cert.certificate_code}
              </span>
              <Link to={`/verify-certificate/${cert.certificate_code}`}>Verify</Link>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default StudentDashboardPage;
